import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {EventosTablaInterface} from '../../interfaces/eventos-tabla.interface';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import * as swalFunctions from '../../data/sweet-alert';
import {ParametrosTablaInterface} from '../../interfaces/parametros-tabla.interface';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Reglux} from '../../constants/reglux';
import {Constants} from '../../constants/constants';
import {ComboBoxService} from '../../services/combo-box.service';
import {UtileriasService} from '../../services/utilerias.service';
import {ItFormInterface} from '../../interfaces/it-form.interface';
import {ComboBoxInterface} from '../../interfaces/combo-box.interface';
import {HttpEventType, HttpResponse} from '@angular/common/http';
import {FilesService} from '../../services/files.service';
import {PsadjuntService} from '../../services/psadjunt.service';
import {TablaValidacionesService} from '../../services/tabla-validaciones.service';
import swal from 'sweetalert2';
import {CpfacturService} from '../../services/cpfactur.service';
import {DatePipe} from '@angular/common';
import {Spring} from '../../spring/spring';
import {ModalVisorDocumentosComponent} from '../modal-visor-documentos/modal-visor-documentos.component';
import {ListenerService} from '../../services/listener.service';

@Component({
  selector: 'app-modal-documentos',
  templateUrl: './modal-documentos.component.html',
  styleUrls: ['./modal-documentos.component.scss'],
  providers: [DatePipe]
})
export class ModalDocumentosComponent implements OnInit, AfterViewInit, ItFormInterface {

  @ViewChild('modalDocumentos') modal: ElementRef;

  @ViewChild('modalVisorDocumentos') modalVisorDocumentos: ModalVisorDocumentosComponent;
  @Output() emitter: EventEmitter<EventosTablaInterface> = new EventEmitter<EventosTablaInterface>();
  @Input() evento: EventosTablaInterface;
  @Input() titulo: string;
  @Input() id: any;
  @Input() filtro: any;

  // Formulario
  adjunto: FormGroup;

  // Variables
  guardado = false;
  swal = swalFunctions;
  eventoResponse: EventosTablaInterface;
  selectedFiles: FileList;
  messageFiles: string;
  listGltipadj: ComboBoxInterface[];
  procesando = false;


  parametrosTabla: ParametrosTablaInterface = {
    dataSource: [],
    displayedColumns: ['tipoAdjunto', 'comentarios', 'fecha', this.constants.VISUALIZAR, this.constants.ELIMINAR_DOCUMENTACION],
    dataNames: ['Documento', 'Comentarios', 'Fecha Carga'],
    formatColumn: [this.constants.TEXT, this.constants.TEXT, this.constants.DATETIME, this.constants.CONTROL, this.constants.CONTROL],
    pageSize: 5,
    pageSizeOptions: [5, 10, 25, 100],
    clasePaginator: 'col-md-12',
    documentacion: true
  }

  constructor(private modalService: NgbModal,
              private formBuilder: FormBuilder,
              private reglux: Reglux,
              private cd: ChangeDetectorRef,
              private constants: Constants,
              private _comboBox: ComboBoxService,
              private _utilerias: UtileriasService,
              private _files: FilesService,
              private _psadjunt: PsadjuntService,
              private _tablaValidaciones: TablaValidacionesService,
              private _cpfactur: CpfacturService,
              private _utileria: UtileriasService,
              private datePipe: DatePipe,
              private spring: Spring,
              private listener: ListenerService) {
  }

  ngOnInit(): void {
    this.updateData();
    this.initForm();
  }

  ngAfterViewInit(): void {
    this.modalService.open(this.modal, {
      backdrop: 'static',
      keyboard: false,
      size: 'xl'
    });

    this.parametrosTabla.tabla = this.evento.tabla;

    if (this.evento.fecha !== undefined) {
      this.parametrosTabla.displayedColumns.unshift('fechaControl');
      this.parametrosTabla.dataNames.unshift('Fecha Control');
      this.parametrosTabla.formatColumn.unshift(this.constants.DATE);
    }
  }

  emit(): void {
    this.evento = {
      accion: ''
    }
    this.emitter.emit(this.evento);
  }

  initForm(): void {
    this.adjunto = this.formBuilder.group({
      idtipadj: ['', [Validators.required]],
      archivo: [''],
      comentarios: ['', [Validators.maxLength(255)]],
      fecha: [''],
      id: [this.id]
    });

    if (this.evento.tablaAdjuntos.trim() === this.constants.INSEGURO_PAGOS && this.evento.accion == this.constants.PAGOS) {
      if (this.evento.objeto.fechaUltimoPagoPoliza === '2000-01-01') {
        this.swal.TypeError('Fecha Último Pago', 'Es necesario capturar la fecha del último pago de la póliza para cargar documentos.')
        this.adjunto.disable();
      } else {
        this.adjunto.enable();
        this.adjunto.get('comentarios').setValue('Fecha Pago: ' + this.datePipe.transform(this.evento.objeto.fechaUltimoPagoPoliza, 'dd-MMM-yyyy')!);
      }
    }
  }

  loadRecord(): void {
    return;
  }

  validateRecord(): boolean {
    if (this.selectedFiles == null) {
      this.swal.TypeError('Sin Archivo', 'Es necesario carga un archivo en formato .pdf valido.');
      return false;
    }
    return true;
  }

  saveOrUpdateRecord(): boolean {
    if (this.validateRecord() === false) {
      return false;
    }
    this.procesando = true;
    this.guardado = true;
    this.uploadFiles();
    return true;
  }

  deleteRecord(): void {

    swal.fire({
      title: '¿Desea eliminar el registro seleccionado?',
      text: '¡No podrás revertir esto!',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, continuar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
        if (result.isConfirmed) {
          this.procesando = true;
          this._psadjunt.deleteAdjunt(this.eventoResponse.objeto.idadjunt, this.evento.rutaSFTP, this.eventoResponse.objeto.archivo)
            .subscribe(res => {
              this.updateData();
              this.swal.TypeSuccess('Archivo eliminado', 'Verifique la información');
              this.cd.markForCheck();
              this.procesando = false;
            }, error => {
              this.swal.TypeErrorDetails(error.error.message, error.error.trace);
              this.procesando = false;
            });

        }
      }
    );
  }

  validateField(campo: string, codigoError: string): boolean {
    return this.adjunto.get(campo).hasError(codigoError);
  }


  getListPsadjuntByIdseguroPagos(): void {
    this._psadjunt.getListPsadjuntByIdseguroPagos(this.evento.objeto.idseguro).subscribe(res => {
      this.parametrosTabla.dataSource = res;
      this.listener.emit(this.constants.ACTUALIZAR_TABLA, this.parametrosTabla.tabla);
      this.cd.markForCheck();
    });
  }


  getListPsadjuntByIdgenral(): void {
    let listAdjuntosRequisiciones = [];
    this._psadjunt.getListPsadjuntByIdgenral(this.evento.objeto.idgenral).subscribe(res => {

      listAdjuntosRequisiciones = res;
      this._cpfactur.getListCpfacturByIdgenral(this.evento.objeto.idgenral).subscribe(obj => {
        obj.forEach((element) => {
          if (element.rutaPDF !== '') {
            const pdf = {
              'archivo': element.rutaPDF,
              'comentarios': '',
              'fecha': '',
              'idadjunt': this.constants.CPFACTUR,
              'tipoAdjunto': 'Factura PDF',
            }
            listAdjuntosRequisiciones.push(pdf);
          }
          if (element.rutaXML !== '') {
            const xml = {
              'archivo': element.rutaXML,
              'comentarios': '',
              'fecha': '',
              'idadjunt': this.constants.CPFACTUR,
              'tipoAdjunto': 'Factura XML'
            }
            listAdjuntosRequisiciones.push(xml);
          }
        });

        this.parametrosTabla.dataSource = listAdjuntosRequisiciones;
        this.listener.emit(this.constants.ACTUALIZAR_TABLA, this.parametrosTabla.tabla);
      })
      this.cd.markForCheck();
    });


  }


  getListPsadjuntByIdgasdet(): void {
    this._psadjunt.getListPsadjuntByIdgasdet(this.evento.objeto.idgasdet).subscribe(res => {
      res.forEach((element) => {
        element.idestatu = this.evento.objeto.idestatu;
      });
      this.parametrosTabla.dataSource = res;
      this.listener.emit(this.constants.ACTUALIZAR_TABLA, this.parametrosTabla.tabla);
      this.cd.markForCheck();
    });
  }


  responseEmitter(evento: EventosTablaInterface): void {
    this.eventoResponse = evento;
    if (this.eventoResponse.accion.trim() === this.constants.VISUALIZAR) {
      this.getFilePDF();
    } else if (this.eventoResponse.accion === this.constants.ELIMINAR_DOCUMENTACION) {
      this.deleteRecord();
    }
  }

  selectFiles(event): void {
    for (const file of event.target.files) {
      if (file.name.split('.').pop().toLowerCase() !== 'pdf' && file.name.split('.').pop().toLowerCase() !== 'xml'
        && file.name.split('.').pop().toLowerCase() !== 'zip' && file.name.split('.').pop().toLowerCase() !== 'rar') {
        this.selectedFiles = null;
        this.swal.TypeError('Error en extensión', 'Verifique la extensión de los archivos adjuntos, las extensiones permitidas son (.pdf,.xml,.zip,.rar)');
        return;
        break;
      }
    }
    this.selectedFiles = event.target.files;
  }


  uploadFiles(): void {
    for (let i = 0; i < this.selectedFiles.length; i++) {
      this.upload(this.selectedFiles[i]);
    }
  }

  upload(file): void {
    this.procesando = true;
    this._files.upload(file, this.evento.tablaAdjuntos, this.evento.rutaSFTP, this.adjunto.value).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.selectedFiles = null;
        } else if (event instanceof HttpResponse) {
          this.selectedFiles = null;
          this.swal.TypeSuccess('Archivo cargado', 'Verifique la información.');
          this.guardado = false;
          this.procesando = false;
        }

        this.cd.markForCheck();
        this.initForm();
        this.updateData();
      },
      err => {
        this.guardado = false;
        this.procesando = false;
        this.messageFiles = 'No se puede subir el archivo ' + file.name;
        this.swal.TypeError('Error Carga', this.messageFiles);

      });

  }

  getFilePDF(): void {
    this.procesando = true;
    if (this.eventoResponse.objeto.idadjunt === this.constants.CPFACTUR) {
      this._psadjunt.getArchivo(this.eventoResponse.objeto.archivo, this.constants.SFTP_CPFACTUR).subscribe(res => {
        this.modalVisorDocumentos.showPDF(this.eventoResponse.objeto.archivo);
        this.procesando = false;
      }, error => {
        this.procesando = false;
        this.swal.TypeErrorDetails(error.error.message, error.error.trace);
      });
    } else {
      this._psadjunt.getArchivo(this.eventoResponse.objeto.archivo, this.evento.rutaSFTP).subscribe(res => {
        this.modalVisorDocumentos.showPDF(this.eventoResponse.objeto.archivo);
        this.procesando = false;
      }, error => {
        this.procesando = false;
        this.swal.TypeErrorDetails(error.error.message, error.error.trace);
      });
    }
  }

  loadComboGltipadjByTabla(): void {
    this._comboBox.getListGltipadjByTabla(this.evento.tablaAdjuntos, this.id, this.filtro).subscribe(res => {
      this.listGltipadj = res;
      this.filtrosCombo();
      this.cd.markForCheck();
    }, error => this.swal.TypeErrorDetails(error.error.message, error.error.trace));
  }


  loadComboGltipadjByInseguroPagos(): void {
    this._comboBox.getListGltipadjByInseguroPagos(this.evento.objeto.idseguro, this.evento.objeto.fechaUltimoPagoPoliza).subscribe(res => {
      this.listGltipadj = res;
      this.cd.markForCheck();
    }, error => this.swal.TypeErrorDetails(error.error.message, error.error.trace));
  }


  getListAdjuntos(): void {

    this._files.getAdjuntos(this.evento.tablaAdjuntos, this.id).subscribe(res => {
      this.parametrosTabla.dataSource = res;
      this.listener.emit(this.constants.ACTUALIZAR_TABLA, this.parametrosTabla.tabla);
      this.filtrosData();
      this.cd.markForCheck();
    });
  }


  updateData(): void {
    switch (this.evento.tablaAdjuntos.trim()) {
      case this.spring.RQGENRAL:
        /** Caso especial **/
        this.loadComboGltipadjByTabla();
        this.getListPsadjuntByIdgenral();
        break;
      case this.spring.CGGASDET:
        /** Caso especial **/
        this.loadComboGltipadjByTabla();
        this.getListPsadjuntByIdgasdet();
        break;
      case this.constants.INSEGURO_PAGOS:
        /** Caso especial **/
        this.getListPsadjuntByIdseguroPagos();
        this.loadComboGltipadjByInseguroPagos()
        break;
      default:
        this.loadComboGltipadjByTabla();
        this.getListAdjuntos();
        break;
    }

  }

  isGranted(): boolean {
    if (this.evento.tablaAdjuntos !== undefined) {
      return this._tablaValidaciones.isGranted(this.evento.tablaAdjuntos.trim(), this.constants.AGREGAR, true);
    } else {
      return false;
    }
  }

  filtrosCombo(): void {
    switch (this.evento.tablaAdjuntos) {
      case this.spring.PSPERSON:
        if (this.evento.objeto.idtipper === 1) { // Fisica
          const ficheros = [1, 2, 6, 8, 21, 24, 51, 58, 50];
          if (this.evento.objeto.idnacion !== 1) {
            ficheros.push(7);
          }
          this.listGltipadj = this.listGltipadj.filter(obj => ficheros.includes(obj.identificador) === true);
        } else { // Moral
          const ficheros = [1, 3, 4, 8, 21, 24];
          this.listGltipadj = this.listGltipadj.filter(obj => ficheros.includes(obj.identificador) === true);
        }
        break;
      case this.spring.INSEGURO:
        switch (this.evento.accion) {
          case this.constants.PAGOS_AMORTIZABLES:
            this.listGltipadj = this.listGltipadj.filter(obj => obj.identificador == 59);
            break;
          case this.constants.DOCUMENTOS:
            this.listGltipadj = this.listGltipadj.filter(obj => obj.identificador != 59);
            break;
        }
        break;
    }

  }

  filtrosData(): void {
    switch (this.evento.tablaAdjuntos) {
      case this.spring.INSEGURO:
        switch (this.evento.accion) {
          case this.constants.PAGOS_AMORTIZABLES:
            this.parametrosTabla.dataSource = this.parametrosTabla.dataSource.filter(obj => obj.idtipadj == 59);
            this.listener.emit(this.constants.ACTUALIZAR_TABLA, this.parametrosTabla.tabla);
            break;
          case this.constants.DOCUMENTOS:
            this.parametrosTabla.dataSource = this.parametrosTabla.dataSource.filter(obj => obj.idtipadj != 59);
            this.listener.emit(this.constants.ACTUALIZAR_TABLA, this.parametrosTabla.tabla);
            break;
        }
        break;
    }

  }

}
